export default defineNuxtPlugin(nuxtApp => {
	const { startPageLoading, forceStopPageLoading } = usePageLoading();
	let readyForLoading = false;

	nuxtApp.hook("app:mounted", () => {
		readyForLoading = true;
	});

	const router = useRouter();

	router.beforeEach((to, from) => {
		if (!readyForLoading) return;
		if (to.path === from.path) return;
		startPageLoading();
	});

	nuxtApp.hook("page:start", () => {
		if (!readyForLoading) return;
		startPageLoading();
	});

	const endLoading = () => {
		if (!readyForLoading) return;
		forceStopPageLoading();
	};

	nuxtApp.hook("page:finish", endLoading);
	router.afterEach(endLoading);

	nuxtApp.hook("vue:error", () => {
		forceStopPageLoading();
	});

	router.onError(() => {
		forceStopPageLoading();
	});
});
